import React from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import { registerServiceWorker } from './utils/registerSW'

// Stale deploy recovery: if a lazy chunk/CSS fails to preload (old cached index),
// clear caches and reload once instead of showing a blank screen.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  const KEY = 'preload-error-reloaded';
  if (sessionStorage.getItem(KEY)) return;
  sessionStorage.setItem(KEY, '1');

  const cleanup = async () => {
    try {
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch {
      // ignore
    }
    window.location.reload();
  };

  void cleanup();
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Register service worker for performance optimization
registerServiceWorker();

